import React from 'react';
import { Dialog, DialogContent, Typography, Chip, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';


const ModernInfoPopup = ({ item, onClose }) => {
  if (!item) return null;

  return (
    <Dialog
        open={!!item}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        transitionDuration={{ enter: 200, exit: 150 }}
        PaperProps={{
        sx: {
            borderRadius: 3,
            boxShadow: 6,
            backgroundColor: '#ffffff',
        },
        }}
        BackdropProps={{
        timeout: 200,
        }}
    >
      <DialogContent sx={{ position: 'relative', padding: 3, borderLeft: 5, borderColor: item.color }}>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ position: 'absolute', top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h6" fontWeight={600} gutterBottom>
          {item.title} - (Rule ID: {item.rule_id})
        </Typography>

        <Box mb={2}>
          <Typography variant="subtitle2" color="textSecondary">
            Status:
          </Typography>
          <Chip
            label={item.result}
            color={item.result === 'FAIL' ? 'error' : 'success'}
            variant="filled"
            size="small"
            sx={{ mt: 0.5 }}
          />
        </Box>

        <Box mb={2}>
            <Typography variant="subtitle2" color="textSecondary">
                Needed Codes:
            </Typography>
            <Typography variant="body2" sx={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
                {item.codes_that_are_needed?.replace(/,/g, ', ') || '—'}
            </Typography>
            </Box>

            <Box mb={2}>
            <Typography variant="subtitle2" color="textSecondary">
                Codes to Check:
            </Typography>
            <Typography variant="body2" sx={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
                {item.codes_to_check_for?.replace(/,/g, ', ') || '—'}
            </Typography>
        </Box>

        <Box mb={2}>
          <Typography variant="subtitle2" color="textSecondary">
            Description:
          </Typography>
          <Typography variant="body2">{item.description || '—'}</Typography>
        </Box>

        {item.tags?.length > 0 && (
          <Box mt={3} display="flex" gap={1} flexWrap="wrap" justifyContent="flex-end">
            {item.tags
              .sort((a, b) => (a.priority || 0) - (b.priority || 0))
              .map((tag, idx) => (
                <Chip
                  key={idx}
                  label={tag.title}
                  sx={{
                    backgroundColor: tag.color,
                    color: '#fff',
                    fontWeight: 500,
                    fontSize: '0.75rem',
                  }}
                />
              ))}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ModernInfoPopup;
